/**
 * @flow
 */

const ls = require('local-storage');

export class AppStore {

  store(key: string, data: any) {
    return ls(key, data);
  }

  get(key: string) {
    return ls(key);
  }

  delete(key: string) {
    return ls.remove(key);
  }

  truncate() {
    ls.clear();
  }

}

const instance = new AppStore();
export default instance;




// WEBPACK FOOTER //
// ./src/App/Services/AppStore.js